/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:

 Handles navigation initiated by clicks on dynamic content (Fragment, CMS, etc).
 Constructs a NavigationItemRecord from data attributes on the element passed to
 the function.
*/
import NavigationItemRecord from '../../lib/records/NavigationItemRecord';
export var findNode = function findNode(_ref) {
  var target = _ref.target,
      tagName = _ref.tagName,
      container = _ref.container;
  var node = target;

  while (node && node !== container) {
    if (node.tagName.toUpperCase() === tagName.toUpperCase()) {
      return node;
    }

    node = node.parentNode;
  }

  return null;
};
export var getNavigationItem = function getNavigationItem(node) {
  return new NavigationItemRecord({
    navigationUrl: node.getAttribute('data-url'),
    displayType: node.getAttribute('data-display-type'),
    forceWindow: node.hasAttribute('data-force-window'),
    externalNavigation: node.hasAttribute('data-external-navigation')
  });
};
export default (function (_ref2) {
  var target = _ref2.target,
      container = _ref2.container,
      handleNavigation = _ref2.handleNavigation;
  var node = findNode({
    target: target,
    container: container,
    tagName: 'a'
  });

  if (node && node.hasAttribute('data-url')) {
    handleNavigation(getNavigationItem(node));
    return true;
  } else {
    return false;
  }
});